var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#FEFCFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.36 10C16.36 9.46957 16.5707 8.96086 16.9458 8.58579C17.3209 8.21071 17.8296 8 18.36 8H25.64C26.1704 8 26.6791 8.21071 27.0542 8.58579C27.4293 8.96086 27.64 9.46957 27.64 10H30C30.5304 10 31.0391 10.2107 31.4142 10.5858C31.7893 10.9609 32 11.4696 32 12V34C32 34.5304 31.7893 35.0391 31.4142 35.4142C31.0391 35.7893 30.5304 36 30 36H14C13.4696 36 12.9609 35.7893 12.5858 35.4142C12.2107 35.0391 12 34.5304 12 34V12C12 11.4696 12.2107 10.9609 12.5858 10.5858C12.9609 10.2107 13.4696 10 14 10H16.36ZM25.64 10H18.36L18.986 12H25.014L25.64 10ZM20.5 29.5C20.5 29.1022 20.658 28.7206 20.9393 28.4393C21.2206 28.158 21.6022 28 22 28C22.3978 28 22.7794 28.158 23.0607 28.4393C23.342 28.7206 23.5 29.1022 23.5 29.5C23.5 29.8978 23.342 30.2794 23.0607 30.5607C22.7794 30.842 22.3978 31 22 31C21.6022 31 21.2206 30.842 20.9393 30.5607C20.658 30.2794 20.5 29.8978 20.5 29.5ZM21 17V26H23V17H21Z",
    fill: "#737B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.d8d1aee401a5f16d5aa47d34386259b0.svg";
export { ForwardRef as ReactComponent };